import { render, staticRenderFns } from "./TSharePop.vue?vue&type=template&id=4bc2c6a0&scoped=true&lang=html&"
import script from "./TSharePop.vue?vue&type=script&lang=js&"
export * from "./TSharePop.vue?vue&type=script&lang=js&"
import style0 from "./TSharePop.vue?vue&type=style&index=0&id=4bc2c6a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc2c6a0",
  null
  
)

export default component.exports